import { MultiSelect, PriceBandIcon } from '@weareopenr/component-library';
import { SelectedMultiOption } from '@weareopenr/component-library/build/components/MultiSelect/utilities';

type PriceBandFilterProps = {
  options: SelectedMultiOption[];
  selected: string[];
  onChange: (priceBands: string[]) => void;
};

export const PriceBandFilter = ({ options, selected, onChange }: PriceBandFilterProps) =>
  options.length > 0 ? (
    <MultiSelect Icon={PriceBandIcon} label="Price Bands" options={options} selected={selected} onChange={onChange} />
  ) : null;
